export default __webpack_public_path__ + "7d72a5766717650b2cfab3c0fceef988.png";